export default {
  addVariable: 'Add parameter',
  defaultVariableText: 'Select a variable',
  checkCompliance: 'Check compliance',
  templateMatches: 'The text matches the template',
  templateNotMatches: 'The text does not match the template',
};
